// Note: when this was set to 500, we were occasionally bumping into AGG's default 5MB response size limit
export const DEPLOYMENTS_PAGE_SIZE = 300;
export const ISSUE_PAGE_SIZE = 40;
export const MAXIMUM_DEPLOYMENTS_TO_FETCH_PER_ISSUE_PAGE = 4000;
export const MAXIMUM_DEPLOYMENT_PAGES_TO_FETCH_PER_ISSUE_PAGE = Math.ceil(
	MAXIMUM_DEPLOYMENTS_TO_FETCH_PER_ISSUE_PAGE / DEPLOYMENTS_PAGE_SIZE,
);
// This number is somewhat arbitrary, but having an upper bound of some kind seems wise
export const MAXIMUM_FETCHABLE_DEPLOYMENTS = 10000;
export const MAXIMUM_FETCHABLE_ISSUES = 1000;
// This is actually 50 in the server, but let it be same as ISSUE_PAGE_SIZE to fully utilize Apollo cache
export const MAXIMUM_ISSUES_PER_DEPLOYMENT_REQUEST = 40;
